import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewACcessTypepageNews from "../../components/AccessType/ViewAcessTypeLayer";



const ViewAcessType= () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb id="title" title="View Access Type" title2="Access Type" link2="/accesstype" />

        {/* AddUserLayer */}
        <ViewACcessTypepageNews />


      </MasterLayout>
    </>
  );
};

export default ViewAcessType;
